import * as actionTypes from "../actions/actionTypes";
const initialState = {
  token: null,
  loading: false,
  userData: null,
  error: null,
  ErrorType: null,
  flags: null,
  skills: null,
  ways: null,
  questions: null,
  questionTypes : null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DATABASE_SSUCCESS:
      return {
        ...state,
        flags: action.flags ? action.flags : state.flags,
        skills : action.skills ? action.skills : state.skills,
        ways : action.ways ? action.ways : state.ways,
        questions : action.questions ? action.questions : state.questions,
        questionTypes : action.questionTypes ? action.questionTypes : state.questionTypes,
      }

    case actionTypes.SIGNUP_START:
      return {
        ...state,
        name: action.name,
        email: action.email,
        password: action.password,
      };
    case actionTypes.SIGNIN_SUCCESS:
      return {
        ...state,
        token: action.token,
        loading: false,
      };
    case actionTypes.SIGNIN_FAIL:
      return {
        ...state,
        error: action.error,
        ErrorType: action.ErrorType,
        loading: false,
      };
    case actionTypes.GET_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: action.userData,
        loading: false,
      };
    case actionTypes.CLEAR_ERROR:
      return {
        ...state,
        error: null,
        ErrorType: null,
      };
    case actionTypes.LOGOUT:
      localStorage.removeItem("token");
      window.location.reload()
      return {
        ...state,
        token: null,
        redirectPath: null,
        userData: null,
      };
    case actionTypes.LOADING_SETTER:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ERROR_SETTER:
      return {
        ...state,
        error: action.error,
        ErrorType: action.ErrorType,
        loading: false,
      };
    case actionTypes.CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.TOKEN_SETTER:
      return {
        ...state,
        token: action.token,
      }
    default:
      return state;
  }
};

export default reducer;
